import { Lock } from "lucide-react";

/**
 * Renders a "Rate locked until …" badge.
 * Pass `until` as an ISO timestamp. If the lock has elapsed, the badge falls
 * back to a neutral "Rate locked at submission" label (we still honor the
 * original quote — we just don't promise the lock indefinitely).
 */
export default function RateLockBadge({ until, compact = false, className = "" }) {
  let label = "Rate locked at submission";
  let active = false;
  if (until) {
    try {
      const ms = new Date(until).getTime() - Date.now();
      if (ms > 0) {
        const hours = Math.floor(ms / 3600000);
        const minutes = Math.floor((ms % 3600000) / 60000);
        active = true;
        label = compact
          ? hours >= 1
            ? `Locked · ${hours}h ${minutes}m left`
            : `Locked · ${minutes}m left`
          : hours >= 1
            ? `Rate locked · ${hours}h ${minutes}m remaining`
            : `Rate locked · ${minutes}m remaining`;
      }
    } catch {
      /* ignore */
    }
  }
  return (
    <span
      data-testid="rate-lock-badge"
      className={`inline-flex items-center gap-1.5 px-2.5 h-7 rounded-full text-[11px] font-semibold border ${
        active
          ? "bg-[#346af8]/8 text-[#346af8] border-[#346af8]/20"
          : "bg-[#0b0d17]/8 text-[#0b0d17] border-[#0b0d17]/15"
      } ${className}`}
      title={
        active
          ? "Your quoted rate stays valid for 24 hours from submission."
          : "Your rate was locked at the time you submitted."
      }
    >
      <Lock className="w-3 h-3" />
      {label}
    </span>
  );
}
